/**
 * Altura limitada para ~3 cards por coluna (titulo fica fora desta area).
 * `lg:max-h-none` removido: em tela cheia / TV o teto continua para nao mostrar 4+ sem rolar.
 */
export const CLASSE_LISTA_FILA_TV = [
  "min-h-0 flex-1 overflow-y-auto overscroll-y-contain",
  "max-h-[min(50vh,18.5rem)] sm:max-h-[min(48vh,27rem)] lg:max-h-[min(52vh,40rem)]",
  "space-y-3 sm:space-y-4",
  "[scrollbar-width:none]",
  "[&::-webkit-scrollbar]:[display:none]",
].join(" ");
